import { atom } from 'recoil';

const selectedTeamIdState = atom<string | null>({
  key: 'selected-team-name-state',
  default: null,
});

export { selectedTeamIdState };
